var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 21.5,
    stroke: "#9E9E9E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3096 12C19.14 12 18.9664 12.0671 18.8362 12.1972C18.5758 12.4576 18.5758 12.8836 18.8362 13.144L27.7475 22.0592L18.9664 30.8403C18.706 31.1006 18.706 31.5267 18.9664 31.787C19.2267 32.0474 19.6527 32.0474 19.9131 31.787L29.1675 22.5326C29.4279 22.2722 29.4279 21.8462 29.1675 21.5858L19.7829 12.1973C19.6527 12.0671 19.4792 12 19.3096 12L19.3096 12Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightSvg);
export default __webpack_public_path__ + "static/media/right-svg.c084d7f8dc95d16cb52a3b1e509dd152.svg";
export { ForwardRef as ReactComponent };